import { gql, useQuery } from '@apollo/client';

import { useState } from 'react';

export const GET_PERMISSIONS_GROUPS = gql`
  query getPermissionsGroups($options: QueryOptionsInput, $companyId: String!) {
    getPermissionsGroups(options: $options, companyId: $companyId) {
      totalCount
      collection {
        _id
        name
        createdBy
        permissions {
          permission
          rule
        }
      }
    }
  }
`;

export const useGetPermissionsGroupsForTable = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([]);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_PERMISSIONS_GROUPS, {
    variables: {
      options: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
      companyId,
    },
    skip: !companyId,
    fetchPolicy: 'cache-and-network',
  });
  const { collection = [], totalCount = 0 } = data?.getPermissionsGroups || {};

  return {
    loading,
    onTableChange: (a: any, b: any, { order }: any) => {
      const sortArray = [];

      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        sortArray.push({ field: 'name', sortBy });
      }

      setNameSort(sortArray);
    },
    permissionsGroups: collection,
    paginationConfig: {
      pageSize,
      total: totalCount,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
  };
};

export const useGetPermissionsGroups = (companyId?: string) => {
  const { data, loading } = useQuery(GET_PERMISSIONS_GROUPS, {
    variables: { companyId },
    skip: !companyId,
    fetchPolicy: 'network-only',
  });
  const { collection = [] } = data?.getPermissionsGroups || {};

  return {
    loading,
    permissionsGroups: collection,
  };
};
